<template>
  <div>
    <ul class="radio-wrapper" v-if="typeRadio">
      <template>
        <li v-for="item in list" :key="item.id"  :title="item.nom">
          <b-form-radio
            class="radio-format"
            v-model="selected"
            :name="type + '-radios'"
            :value="item.id"
            @change="handleChange(item.id)"
            >{{ item.nom }}
            <font-awesome-icon
              class=""
              v-if="selected === item.id"
              :icon="['fas', 'angle-right']"
          /></b-form-radio>
        </li>
      </template>
    </ul>
    <b-form-group v-else class="checkbox-wrapper">
      <b-form-checkbox v-if="this.listElement.length"
        v-model="allSelected"
        :indeterminate="indeterminate"
        aria-describedby="espaces"
        aria-controls="espaces"
        @change="toggleAll"
        >Toutes les données</b-form-checkbox
      >
      <template>
        <b-form-checkbox-group
          v-model="checkBoxSelected"
          :id="type + '-checkbox'"
          :name="type + '-checkbox'"
          :options="listElement"
          html-field="linkedLabel"
          stacked
        ></b-form-checkbox-group>
      </template>
    </b-form-group>
  </div>
</template>
<script>
import { events, EventBus } from '../../eventBus'
import { mapGetters } from 'vuex'
export default {
  props: {
    type: String,
    list: Array,
    typeRadio: Boolean,
    linkedData: Array
  },
  data () {
    return {
      selected: null,
      checkBoxSelected: [],
      allSelected: false,
      indeterminate: false
    }
  },
  mounted () {
    EventBus.$on(events.RESET_FILTER, () => {
      this.selected = null
      this.checkBoxSelected = []
    })
  },
  computed: {
    listElement () {
      return this.list.map(x => {
        const item = {
          text: x.title.trim(),
          value: {
            idTableau: x.idTableau,
            key: x.key,
            rowNo: x.rowNo
          }
        }
        if (this.isInArray(this.linkedData, item.value)) {
          item.linkedLabel = `<span class="text-primary font-weight-bolder">${x.title.trim()}</span>`
        } else {
          item.linkedLabel = `<span>${x.title.trim()}</span>`
        }
        return item
      })
    }
  },
  watch: {
    checkBoxSelected (newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.list.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }

      this.$emit('multiSelect', newVal)
    }
  },
  methods: {
    ...mapGetters(['disabledAddTableau', 'isCopied']),
    compareObjectData (o1, o2) {
      return Object.keys(o1).every(key => {
        return o1[key] === o2[key]
      })
    },
    isInArray (arr, obj) {
      return arr.some(el => this.compareObjectData(el, obj))
    },
    handleChange (id) {
      this.$emit('selected', id, this.type)
      // EventBus.$emit(events.SELECT_PROJECT, id, this.type)
    },
    toggleAll (checked) {
      this.checkBoxSelected = checked ? this.listElement.map(x => x.value).flat() : []
    }
  }
}
</script>
<style lang="scss">
.radio-wrapper {
  list-style: none;
  padding-left: 0;
  // height: 250px;
  overflow-y: auto;
  li {
    box-shadow: inset 0 -1px 0 0 #f2f7fa;
    height: 25px;
    line-height: 25px;
    .custom-control {
      padding-left: 0;
      padding-right: 8px;
      .custom-control-input:checked {
        & ~ label {
          color: #fff;
          background-color: #2b3085;
        }
      }
    }
    label {
      font-size: 12px;
      display: block;
      padding-left: 15px;
      padding-right: 15px;
      font-weight: 500;
      width: 100%;
      cursor: pointer;
      &::after,
      &::before {
        display: none;
      }
    }
  }
  .radio-format {
    label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      svg {
        font-size: 16px;
      }
    }
  }
}
.wrapper-py5 {
  padding: 5px 0;
}
.checkbox-wrapper {
  padding: 0 15px;
  .custom-control {
    // box-shadow: inset 0 -1px 0 0 #f2f7fa;
    height: 25px;
    line-height: 25px;
    label {
      vertical-align: middle;
      color: #2b3085;
      font-size: 12px;
    }
    .custom-control-label {
      &:before,
      &:after {
        top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/dataFilterList.vue